// @ts-ignore
import widgetLib from '@sitebuilder/widget-lib';
import { types as commonTypes } from '@sitebuilder/common';
import Header from './Header';
import HtmlBlock from './HtmlBlock';
import RichTextEditable from './RichTextEditable';
import KeyValuePairTable from './KeyValuePairTable';
import MultiColumn from './MultiColumn';
import PieChart from './PieChart';
import HoldingsContainer from './HoldingsContainer';
import Repeater from './Repeater';
import RiskIndicator from './RiskIndicator';
import TitledSection from './TitledSection';
import SubSections from './SubSections';
import TwoColumn from './TwoColumn';
import Table from './Table';
import Section from './Section';
import Link from './Link';
import Text from './Text';
import DailyPrice from './DailyPriceWidget';
import Image from './Image';
import GrowthChart from './GrowthChart';
import StockChart from './StockChart';
import ReturnsBarChart from './ReturnsBarChart';
import ShareLink from './ShareLink';
import DropDown from './Dropdown';
import Manager from './Manager';
import ManagersContainer from './ManagersContainer';
import IconIndicator from './IconIndicator';
import Disclaimer from './Disclaimer';
import Navbar from './Navbar';
import ExpandableTable from './ExpandableTable';
import RiskMetricTable from './RiskMetricTable';
import FundList from './FundList';
import FavoriteButton from './FavoriteButton';
import BarChart from './BarChart';
import AreaPlotChart from './AreaPlotChart';
import DataProviderWebProfile from './DataProviderWebProfile';
import GeographicAllocationMap from './GeographicAllocationMap';
import Annotations from './Annotations';
import ChartTable from './ChartTable';
import HoldingsOverTimeChart from './HoldingsOverTime';
import Carousel from './Carousel';
import EquityBox from './EquityBox';
import DownloadBox from './DownloadBox';
import PricesTable from './PricesTable';
import ListDocuments from './ListDocuments';
import ConditionalRender from './ConditionalRender';
import Modal from './Modal';
import DistributionsTable from './DistributionsTable';
import MultiList from './MultiList';
import List from './List';
import ChainedContentFlow from './ChainedContentFlow';
import ReferenceComponent from './ReferenceComponent';
import RepeaterWidget from './RepeaterWidget';
import FundCodesTable from './FundCodesTable';
import CustomQueries from './CustomQueries';
import DataContext from './DataContext';
import MultiDropdown from './MultiDropdown';
import DropdownWithCustomQuery from './DropdownWithCustomQuery';
import ExpandCollapseSections from './ExpandCollapseSections';
import ModalOnLoad from './ModalOnLoad';
import DownloadCSV from './DownloadCSV';
import Page from './Page';
import AnalyticsOnLoad from './AnalyticsOnLoad';
import FilterWithCustomQuery from './FilterWithCustomQuery';
import ScalingWidget from './ScalingWidget';
import DownloadWithQuery from './DownloadWithQuery';
import PeriodChart from './PeriodChart';
import SchemaBuilder from './SchemaBuilder';
import CustomizedFundList from './CustomizedFundList';
import RootDocumentComp from './RootDocument/RootDocument';
import document from './RootDocument';

const rec: Record<string, commonTypes.IWidget> = {
    AnalyticsOnLoad,
    Annotations,
    AreaPlotChart,
    BarChart,
    Carousel,
    ChartTable,
    ChainedContentFlow,
    ConditionalRender,
    CustomQueries,
    CustomizedFundList,
    DataContext,
    DataProviderWebProfile,
    DailyPrice,
    Disclaimer,
    DistributionsTable,
    DownloadBox,
    DownloadCSV,
    DownloadWithQuery,
    DropdownWithCustomQuery,
    DropDown,
    EquityBox,
    ExpandCollapseSections,
    ExpandableTable,
    FavoriteButton,
    FilterWithCustomQuery,
    FundCodesTable,
    FundList,
    GeographicAllocationMap,
    GrowthChart,
    Header,
    HoldingsContainer,
    HoldingsOverTimeChart,
    HtmlBlock,
    RichTextEditable,
    IconIndicator,
    Image,
    KeyValuePairTable,
    Link,
    List,
    ListDocuments,
    Manager,
    ManagersContainer,
    Modal,
    ModalOnLoad,
    MultiColumn,
    MultiDropdown,
    MultiList,
    Navbar,
    Page,
    PeriodChart,
    PieChart,
    PricesTable,
    ReferenceComponent,
    Repeater,
    RepeaterWidget,
    ReturnsBarChart,
    RiskIndicator,
    RiskMetricTable,
    ScalingWidget,
    Section,
    ShareLink,
    StockChart,
    SubSections,
    Table,
    Text,
    TitledSection,
    TwoColumn,
    SchemaBuilder,
    document,
};

// export RootDocumentComp
export { RootDocumentComp };

export class WidgetFactory {
    getWidget(id: string): commonTypes.IWidget | null {
        return rec[id] || null;
    }

    listWidgetIds(): string[] {
        return Object.keys(rec);
    }
}

export default rec;
